// Frontend-safe mirror of the Prisma `ClubTier` enum (#1151), same convention
// as `BookingStatusType` in booking.ts. Drives the partner-detail Tier pill.
export enum ClubTier {
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM',
  COMMUNITY = 'COMMUNITY',
}

/**
 * #3149 - lean club projection returned by `GET manage-clubs-api?view=options`.
 * Enough to render a Location dropdown; use ClubI only where full rows are needed.
 */
export type ClubOptionI = Pick<ClubI, 'id' | 'clubName' | 'city' | 'state'> & { isActive?: boolean };

export interface ClubI {
  address1: string;
  address2: string;
  city: string;
  clubInRegionId?: null;
  clubLogo: string;
  clubName: string;
  note?: string;
  clubNoteId?: null;
  clubTeamsId?: null;
  commission: number;
  contactName: string;
  contactTitle?: string;
  createdAt: string;
  id: string;
  isClubACompany: false;
  /** #1151 — defaults true; drives the "Active partners" headline stat + Status pill. Optional: narrower projections may not select it. */
  isActive?: boolean;
  /** #1151 — defaults STANDARD; drives the partner-detail Tier pill. Optional: narrower projections may not select it. */
  tier?: ClubTier;
  lastAmount: number;
  locationId?: string;
  phoneNumber: string;
  emailAddress: string;
  signupUrl: string | null;
  state: string;
  uid?: string;
  updatedAt: string;
  zipCode: string;
  // address1: string;
  // address2: string;
  // zipCode: string;
  // city: null;
  // club_id: string;
  // id: string;
  // // club_name: string;
  // contact_name: null;
  // clubName: string;
  // contact_title: null;
  // country: null;
  // createdAt: string;
  // fax: null;
  // phone: null;
  // postal_code: null;
  // region: null;
  // state: string;
  // updatedAt: string;

  // id: string;
  // clubName: string;
  // address1: string;
  // address2: string;
  // city: string;
  // state: string;
  // zipCode: string;
  // phoneNumber: string;
  // uid: string | null;
  // lastAmount: number;
  // commission: number;
  // region: string;
  // company: boolean;
  // createdAt?: string;
  // updatedAt?: string;
  // location?: {
  //   latitude: number;
  //   longitude: number;
  // };
}

/** Derived partner-gym lifecycle (#3050). No schema column — computed from `isActive` + `signupUrl`. */
export type ClubLifecycleStatus = 'INACTIVE' | 'ACTIVE' | 'ONBOARDING';

/** Segmented-filter value on the Partner gyms list: a lifecycle status or everything. */
export type ClubStatusFilter = 'ALL' | ClubLifecycleStatus;

/**
 * Single source of truth for a partner gym's lifecycle status, shared by the
 * list table and the detail hero. `isActive` defaults true in the DB, so an
 * undefined projection is treated as active; only an explicit `false` is Inactive.
 */
export function clubLifecycleStatus(club: Pick<ClubI, 'isActive' | 'signupUrl'>): ClubLifecycleStatus {
  if (club.isActive === false) {
    return 'INACTIVE';
  }
  return club.signupUrl ? 'ACTIVE' : 'ONBOARDING';
}

// export interface LocationI {
//   latitude: number;
//   longitude: number;
// }
// address1: '808 Borer Dale';
// address2: null;
// city: 'West Clementinabury';
// clubInRegionId: null;
// clubLogo: 'https://cloudflare-ipfs.com/ipfs/Qmd3W5DuhgHirLHGVixi6V76LhCkZUz6pnFt5AJBiyvHye/avatar/353.jpg';
// clubName: 'ClubGusikowski and Sons';
// clubNoteId: null;
// clubTeamsId: null;
// commission: '0';
// contactName: 'Trainer Roberta';
// createdAt: '2023-11-11T15:45:15.996Z';
// id: '5431840b-a102-4caf-b865-6dd199a5c92e';
// isClubACompany: false;
// lastAmount: '0';
// locationId: null;
// phoneNumber: '1-365-721-0282 x985';
// signupUrl: null;
// state: 'OR';
// uid: null;
// updatedAt: '2023-11-11T15:45:15.996Z';
// zipCode: '28808';
